// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import Ellipsis, { EllipsisProps } from '@shared/components/Ellipsis';
import Config from '@core/config';
import container from '@core/di';

export interface VersionTagProps extends Omit<EllipsisProps, 'text'> {
  className?: string;
}

const VersionTag: React.FC<VersionTagProps> = (props) => {
  const config = container.get<Config>(Config.diToken);
  const { version } = config.get();
  const { maxWidth } = props;
  const classes = withStyles.getClasses(props);

  return (
    <Ellipsis classes={{ root: classes.root }} maxWidth={maxWidth} text={version} />
  );
};

const VersionTagStyled = withStyles(
  VersionTag, 
  (theme, props) => ({
    "root": {
      maxWidth: 200,
      position: 'absolute',
      bottom: 8,
      left: 8,
      fontSize: 11,
      zIndex: 999999,
      color: theme.palette.colors.greyDark2,
      fontWeight: 600,
      transition: `${theme.transitions.duration.standard}s`,
    }
  })
);

export default VersionTagStyled;